import { type IntegrationJob } from '@myre/app-am-generated/types/IntegrationJob';
import { type ReplayImportResponse } from '@myre/app-am-generated/types/ReplayImportResponse';

import { createAction, props } from '@ngrx/store';

const MODULE_PREFIX = 'integration';

export const getIntegrationJobsRequest = createAction(
  `${MODULE_PREFIX}/GET_INTEGRATION_JOBS_REQUEST`,
);

export const getIntegrationJobsSuccess = createAction(
  `${MODULE_PREFIX}/GET_INTEGRATION_JOBS_SUCCESS`,
  props<{ integrationJobs: readonly IntegrationJob[] }>(),
);

export const getIntegrationJobsError = createAction(
  `${MODULE_PREFIX}/GET_INTEGRATION_JOBS_ERROR`,
);

export const leaveIntegration = createAction(`${MODULE_PREFIX}/LEAVE`);

export const replayImportsRequest = createAction(
  `${MODULE_PREFIX}/REPLAY_IMPORTS_REQUEST`,
  props<{
    customerId: number;
    importId: string;
    idMapIds: readonly number[];
  }>(),
);

export const replayImportsSuccess = createAction(
  `${MODULE_PREFIX}/REPLAY_IMPORTS_SUCCESS`,
  props<{ response: ReplayImportResponse }>(),
);

export const replayImportsError = createAction(
  `${MODULE_PREFIX}/REPLAY_IMPORTS_ERROR`,
  props<{ error: any }>(),
);

export const showReplayImportsResultModal = createAction(
  `${MODULE_PREFIX}/SHOW_REPLAY_IMPORTS_RESULT_MODAL`,
  props<{ response: ReplayImportResponse }>(),
);
